import { render, staticRenderFns } from "./SCP.vue?vue&type=template&id=6bd164a6&"
import script from "./SCP.vue?vue&type=script&lang=js&"
export * from "./SCP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd164a6')) {
      api.createRecord('6bd164a6', component.options)
    } else {
      api.reload('6bd164a6', component.options)
    }
    module.hot.accept("./SCP.vue?vue&type=template&id=6bd164a6&", function () {
      api.rerender('6bd164a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/SCP.vue"
export default component.exports